import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Heart, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';
import { apiClient } from '../api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await apiClient.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      toast.error('Could not send reset link', { description: err.response?.data?.detail || '' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-fnl-dark flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8" data-testid="forgot-logo">
          <div className="relative">
            <span className="text-white font-bold text-3xl">F</span>
            <Heart className="absolute -top-1 -right-3 w-4 h-4 fill-fnl-pink text-fnl-pink" />
          </div>
          <span className="text-white font-semibold text-lg">Flirty</span>
        </Link>
        <div className="bg-fnl-purple/80 backdrop-blur rounded-2xl p-8 border border-purple-900/50">
          {sent ? (
            <div className="text-center" data-testid="forgot-sent">
              <Mail className="w-12 h-12 text-fnl-pink mx-auto mb-3" />
              <h2 className="text-2xl font-bold text-white mb-2">Check your inbox</h2>
              <p className="text-purple-200 text-sm">
                If an account exists for <span className="text-white font-semibold">{email}</span>, we just sent a password reset link. The link is valid for 2 hours.
              </p>
              <Link to="/login" className="inline-flex items-center gap-1 text-fnl-pink hover:underline font-semibold mt-6">
                <ArrowLeft className="w-4 h-4" />Back to login
              </Link>
            </div>
          ) : (
            <>
              <h2 className="text-2xl font-bold text-white mb-2 text-center">Forgot password?</h2>
              <p className="text-purple-300 text-sm text-center mb-6">
                Enter the email tied to your account and we'll send a reset link.
              </p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <label className="text-white text-sm mb-2 block">Email</label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-purple-300" />
                    <Input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="you@example.com"
                      className="pl-10 bg-white/95 border-0 h-12"
                      data-testid="forgot-email"
                      required
                    />
                  </div>
                </div>
                <Button type="submit" disabled={loading} className="w-full h-12 bg-fnl-pink hover:bg-fnl-pink text-white font-semibold btn-shadow-pink" data-testid="forgot-submit">
                  {loading ? 'Sending...' : 'Send reset link'}
                </Button>
              </form>
              <p className="text-center text-purple-200 text-sm mt-6">
                Remembered it? <Link to="/login" className="text-fnl-pink hover:underline font-semibold">Sign in</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
